// @ts-nocheck
import ReservationApi from "./ReservationApi";

class V3ReservationApi implements ReservationApi {
  fetchCustom: (
      url: string,
      options?: any,
      addAuthHeader?: boolean
  ) => Promise<any>;

  constructor(
      fetchC: (
          url: string,
          options?: any,
          addAuthHeader?: boolean
      ) => Promise<any>
  ) {
    this.fetchCustom = fetchC;
  }

  createReservation = (reservationProps: {}) => {
    // Walley migration: BE renamed `/anonymous/reservations/create-paytrail` to
    // `/anonymous/reservations/create` and collapsed the polymorphic
    // {action, providers, redirectUrl} response to a flat {reservation, price}.
    // The post-create handler in MakeReservation.tsx no longer switches on
    // response.action — it branches on the FE-side paymentMethodCode instead.
    const fetchUrl = `/anonymous/reservations/create`;
    let pageUrl = window.location.hostname;
    let returnDomain = pageUrl.includes('dev-frontend.24rent.fi')
    || pageUrl.includes('www.24rent.fi') ? 'www.24rent.fi' :
        pageUrl.includes('localhost') ? 'localhost' : 'rent.24rent.fi';
    if (returnDomain !== 'localhost' && sessionStorage.getItem('redirectRef') === 'launcher') {
      returnDomain = '24launcher.' + returnDomain;
    }

    reservationProps.key = window.__env?.RESERVATION_KEY || '';
    reservationProps.returnDomain = returnDomain;
    reservationProps.bookingChannel = V3ReservationApi.resolveBookingChannel(pageUrl, reservationProps.oneway);
    return this.fetchCustom(
        fetchUrl,
        {
          method: "POST",
          body: JSON.stringify(reservationProps)
        },
    );
  };

  cancelReservation = (reservationId: number) => {
    if (reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation number or hash"))
    }
    const fetchUrl = `/anonymous/cancel?id=` + reservationId;

    return this.fetchCustom(fetchUrl);
  };

  getOnSalesAd = () => {
    return this.fetchCustom(`/vehicles/get-onsales-ad`)
  };

  payWithSavedWalleyCard = (reservationId: number) => {
    if (!reservationId || reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation id for saved card payment"));
    }
    return this.fetchCustom(
        `/reservations/${reservationId}/pay-with-saved-walley-card`,
        { method: "POST" },
    );
  };

  createPaytrailReservation = (reservationProps: {}) => {
    const fetchUrl = `/anonymous/reservations/create-paytrail`;
    let pageUrl = window.location.hostname;
    let returnDomain = pageUrl.includes('dev-frontend.24rent.fi')
    || pageUrl.includes('www.24rent.fi') ? 'www.24rent.fi' :
        pageUrl.includes('localhost') ? 'localhost' : 'rent.24rent.fi';
    if (returnDomain !== 'localhost' && sessionStorage.getItem('redirectRef') === 'launcher') {
      returnDomain = '24launcher.' + returnDomain;
    }

    reservationProps.key = window.__env?.RESERVATION_KEY || '';
    reservationProps.returnDomain = returnDomain;
    reservationProps.bookingChannel = V3ReservationApi.resolveBookingChannel(pageUrl, reservationProps.oneway);
    return this.fetchCustom(
        fetchUrl,
        {
          method: "POST",
          body: JSON.stringify(reservationProps)
        },
    );
  };

  getPaytrailUrl = (reservationId: number, phoneNumber?: string) => {
    if (!reservationId || reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation id for Paytrail URL"));
    }
    let pageUrl = window.location.hostname;
    let returnDomain = pageUrl.includes('dev-frontend.24rent.fi')
    || pageUrl.includes('www.24rent.fi') ? 'www.24rent.fi' :
        pageUrl.includes('localhost') ? 'localhost' : 'rent.24rent.fi';
    if (returnDomain !== 'localhost' && sessionStorage.getItem('redirectRef') === 'launcher') {
      returnDomain = '24launcher.' + returnDomain;
    }
    let fetchUrl = `/reservations/${reservationId}/get-paytrail-url?returnDomain=${returnDomain}`;
    if (phoneNumber && phoneNumber !== "")
      fetchUrl += '&phonenumber=' + encodeURIComponent(phoneNumber);
    return this.fetchCustom(fetchUrl);
  };

  private static resolveBookingChannel(hostname: string, oneway: boolean | undefined): string {
    const redirectRef = sessionStorage.getItem('redirectRef');
    const isOneway = oneway || sessionStorage.getItem('oneway') === 'true'
    const isWpHost = hostname.includes('www.24rent.fi') || hostname.includes('dev-frontend.24rent.fi');

    if (redirectRef === 'launcher') {
      return isOneway ? 'Launcher-Oneway' : 'Launcher-RRM';
    }
    if (redirectRef === 'chauffeur') {
      return isOneway ? 'Chauffeur-Oneway' : 'Chauffeur-RRM';
    }
    if (isWpHost) {
      return isOneway ? 'Oneway' : 'RRM';
    }
    if (hostname.includes('rent.24rent.fi') || hostname.includes('dev-rent.24rent.fi') || hostname.includes('localhost')) {
      return isOneway ? 'Oneway-rent' : 'RRM-rent';
    }
    return 'Unknown';
  }

}

export default V3ReservationApi;
